// Finalized copy — sourced from DesignIndya_Website_Copy_v2.md

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_design-studio-demo-2/artifacts/mhcl891n_DeisgnIndya%20Logo.png";

export const NAV_LINKS = [
  { label: "What We Do", to: "/services" },
  { label: "Our Work", to: "/work" },
  { label: "Our Story", to: "/about" },
  { label: "Insights", to: "/#insights" },
  { label: "Investors", to: "/investors" },
];

export const HERO = {
  preTag: ["Better Advertising", "Since 2008"],
  headlineLines: ["Brands,", "reach Bharat."],
  // The current homepage (HomePageV2 — logo-ticker variant). Lines 1 and 3
  // are bolded; line 2 carries the supporting context.
  subLines: [
    [{ text: "Brands choose Designindya —", hl: true }],
    [
      { text: "17 years of ad expertise & 1,000+ media partners" },
    ],
    [
      { text: "to command attention across Bharat.", hl: true },
    ],
  ],
};

// Legacy sub-copy retained for /v2 (the original text-ticker landing page).
export const HERO_LEGACY_SUB_LINES = [
  [{ text: "Across print, broadcast, OOH, BTL, and digital," }],
  [
    { text: "Designindya", hl: true },
    { text: " navigates 1,000+ media partners" },
  ],
  [
    { text: "and ", },
    { text: "gets your brand the attention it deserves.", hl: true },
  ],
];

export const CAPABILITIES_TABS = [
  {
    id: "placement",
    label: "Placement",
    items: [
      "Print & Publications",
      "Broadcast",
      "Out-of-Home",
      "Cinema",
      "Airport",
      "Hyperlocal",
      "Digital",
      "BTL & Events",
      "Government Advertising",
    ],
  },
  {
    id: "strategy",
    label: "Strategy",
    items: [
      "Media Planning",
      "Budget Advisory",
      "Campaign Advisory",
      "Rate Optimisation",
      "Go-to-Market",
      "Market Entry Planning",
    ],
  },
  {
    id: "creative",
    label: "Creative",
    items: [
      "Brand Identity",
      "Ad Production",
      "Copywriting",
      "Campaign Design",
      "Web & Digital",
    ],
  },
  {
    id: "measurement",
    label: "Measurement",
    items: [
      "Campaign Tracking",
      "Ad Audit",
      "Post-Campaign Analysis",
      "MIS Reporting",
      "Performance Reporting",
    ],
  },
];

export const HERO_TESTIMONIALS = [
  {
    id: "sanjeev-juneja",
    quote:
      "Throughout the years of working together, I can guarantee that DesignIndya's team stays on top of the current trends with its exceptional marketing and communications niche.",
    name: "Dr Sanjeev Juneja",
    role: "Promoter",
    company: "Divisa Herbals Pvt Ltd",
    initials: "SJ",
    companyMark: "DIVISA",
  },
  {
    id: "ps-chatwal",
    quote:
      "DesignIndya has been a great partner in our Print, social media marketing and marketing efforts.",
    name: "PS Chatwal",
    role: "MD",
    company: "Torque Pharmaceuticals Pvt Ltd",
    initials: "PC",
    companyMark: "TORQUE",
  },
  {
    id: "amit-gupta",
    quote:
      "DesignIndya team is a bunch of incredibly talented and passionate professionals who have done a tremendous job in helping us establishing the brand.",
    name: "Mr Amit Gupta",
    role: "Director",
    company: "Leeford Healthcare",
    initials: "AG",
    companyMark: "LEEFORD",
  },
  {
    id: "dheeraj-aggarwal",
    quote:
      "A true agency partner that is talented and nimble. I can confidently recommend this agency to clients in need of effective advertising.",
    name: "Mr Dheeraj Aggarwal",
    role: "Director",
    company: "Emami Ltd",
    initials: "DA",
    companyMark: "EMAMI",
  },
];

// Media partner testimonials — to be populated as we collect them
export const MEDIA_TESTIMONIALS = [];

export const CAPABILITIES_TICKER = [
  "Ad Placement",
  "Print & Publications",
  "Broadcast Media",
  "Out-of-Home",
  "Below the Line",
  "Events",
  "Digital",
  "Government Advertising",
  "Branding",
  "Creative",
  "Copywriting",
  "Go-to-Market",
  "Campaign Advisory",
];

export const LEADERSHIP = [
  {
    id: "rakesh-jain",
    name: "Rakesh Jain",
    role: "Founder & MD",
    initials: "RJ",
    photo: "/leadership/rakesh-jain.jpg",
    linkedin: "https://www.linkedin.com/in/rakeshjainofcl/",
    email: "md@designindya.com",
    bio: [
      "Rakesh Jain founded Designindya in 2008 in Ludhiana with a straightforward belief: that Indian brands deserved better media access, and the path to that access went through relationships and volume.",
      "Seventeen years later, that belief has become a ₹200+ crore media operation spanning seven offices and 150+ clients. He runs the business with the same directness he started it with.",
    ],
  },
  {
    id: "raman-kumar-chugh",
    name: "Raman Chugh",
    role: "Hype 'n' Hike",
    initials: "RC",
    linkedin: "https://www.linkedin.com/in/raman-kumar-chugh-b64463201/",
    email: "Ramankchugh@designindya.com",
    bio: [
      "A seasoned advertising professional with over two decades of experience, Raman Chugh brings strong expertise in media strategy, partnerships, and business development.",
      "As an entrepreneur and strategic advisor, he has built and scaled networks across Bharat and the GCC, driving market expansion and cross-border growth.",
      "After Designindya acquired Hype 'N' Hike, he decided to stay on as a force multiplier for the team.",
    ],
  },
  {
    id: "manish-sharma",
    name: "Manish Sharma",
    role: "AVP — West Sales",
    initials: "MS",
    linkedin: null,
    email: "manish@designindya.com",
    bio: [
      "After more than two decades of travel in sales across the globe and assuming diverse responsibilities in Publication Houses and Media Agencies, Manish Sharma dove head-first into the Designindya ecosystem.",
      "His expertise in media planning, execution and high-quality, scalable customer service is a cornerstone of our brand relationships.",
    ],
  },
  {
    id: "suresh-kothari",
    name: "Suresh Kothari",
    role: "Chief Financial Officer",
    initials: "SK",
    linkedin: "https://www.linkedin.com/in/suresh-kothari-98269960/",
    email: "cfo@designindya.com",
    bio: [
      "A seasoned leader with over four decades of experience across finance and advertising, Suresh Kothari brings a rare combination of financial discipline and revenue insight.",
      "At Dainik Bhaskar, he rose from core F&A roles to lead national ad sales, managing large client relationships and driving strong growth.",
      "He weaves financial stewardship with a clear understanding of how growth is delivered — indispensable for our next chapter.",
    ],
  },
  {
    id: "cheshta-jain",
    name: "Cheshta Jain",
    role: "Chief of Staff",
    initials: "CJ",
    linkedin: "https://www.linkedin.com/in/cheshta-jain-84673b1a3/",
    email: "cheshta@designindya.com",
    bio: [
      "Cheshta completed her BBA from NMIMS Mumbai — one of India's leading business schools — before building experience across the advertising ecosystem through stints at Dainik Jagran, Madison World, and Transmitter Branding.",
      "That cross-functional exposure — media planning, strategy, and digital — informs how she approaches the Chief of Staff role at Designindya.",
      "She keeps the business moving: across operations and leadership coordination.",
    ],
  },
  {
    id: "arvind-kothari",
    name: "Arvind Kothari",
    role: "Advisor, Strategy",
    initials: "AK",
    photo: "/leadership/arvind-kothari.jpg",
    linkedin: "https://www.linkedin.com/in/arvikot/",
    email: "arvind@designindya.com",
    bio: [
      "Arvind Kothari is a hands-on advisor with 15 years of experience working closely with senior leadership across Energy, Mining, FMCG, and Tech tackling high-stakes problems and driving results.",
      "Known for bringing structure to unclear situations and aligning teams to move ideation to action, he combines clear strategic thinking with a strong bias for execution — both within Designindya and for the brands we serve.",
    ],
  },
];

export const SECTORS = [
  "Healthcare & Pharma",
  "FMCG",
  "Financial Services",
  "Real Estate",
  "Education",
  "Automobile",
  "Footwear",
  "Jewellery",
  "Government",
];

export const SCALE_STATS = [
  { value: "₹200+", suffix: " Cr", label: "Ads Placed Annually", short: "Media Placed", tickerKey: "sectors" },
  { value: "150", suffix: "+", label: "Brands Served", short: "Brands", tickerKey: "brands" },
  { value: "1,000", suffix: "+", label: "Media Partners", short: "Media Partners", tickerKey: "media" },
  { value: "18", suffix: "", label: "Languages", short: "Languages", tickerKey: "languages" },
];

export const TICKER_BRANDS = [
  "Emami",
  "Cipla Health",
  "Leeford Healthcare",
  "Torque Pharma",
  "Indira IVF",
  "Divisa Herbal",
  "Patanjali",
  "Zandu",
  "Boro Plus",
  "Navratna",
  "Pushp",
  "CT University",
  "Flame University",
  "Mody University",
  "Aakash Institute",
  "John Deere",
  "Sonalika",
  "Kubota",
  "Indo Farm",
  "Hero Ecotech",
  "JSW Cement",
  "Jai Bharat Steel",
  "KONE Elevators",
  "Prayag Pipes",
  "APL Footwear",
  "Calcetto",
  "Aeroblu",
];

// Real client logos for the Landing v2 ticker. Each entry resolves to an
// optimised 96px-tall PNG in /public/logos/brands/. Order is loosely grouped
// by sector (healthcare → wellness/FMCG → education → real estate / retail).
export const TICKER_BRAND_LOGOS = [
  // Healthcare & Pharma
  { src: "/logos/brands/indira-ivf.png", title: "Indira IVF" },
  { src: "/logos/brands/hiims.png", title: "HIIMS" },
  { src: "/logos/brands/leeford.png", title: "Leeford Healthcare" },
  { src: "/logos/brands/sbl.png", title: "SBL" },
  { src: "/logos/brands/marengo-asia.png", title: "Marengo Asia" },
  { src: "/logos/brands/cancer-healer.png", title: "Cancer Healer" },
  { src: "/logos/brands/torex.png", title: "Torex" },
  // FMCG / Wellness / Ayurveda
  { src: "/logos/brands/emami-7-oils.png", title: "Emami 7 Oils" },
  { src: "/logos/brands/navratna-oil.png", title: "Navratna" },
  { src: "/logos/brands/vicco.png", title: "Vicco" },
  { src: "/logos/brands/keshking.png", title: "Kesh King" },
  { src: "/logos/brands/roop-mantra.png", title: "Roop Mantra" },
  { src: "/logos/brands/raj-soap.png", title: "Raj Soap" },
  { src: "/logos/brands/goodricke.png", title: "Goodricke" },
  // Education
  { src: "/logos/brands/physics-wallah.png", title: "Physics Wallah" },
  { src: "/logos/brands/drishti-ias.png", title: "Drishti IAS" },
  { src: "/logos/brands/mody-univ.png", title: "Mody University" },
  // Real Estate / Infra
  { src: "/logos/brands/gaursons.png", title: "Gaursons" },
  { src: "/logos/brands/migsun.png", title: "Migsun" },
  { src: "/logos/brands/plasto.png", title: "Plasto" },
  { src: "/logos/brands/anchor.png", title: "Anchor" },
  // Retail / Jewellery / Apparel
  { src: "/logos/brands/v-mart.png", title: "V-Mart" },
  { src: "/logos/brands/max-logo.png", title: "Max" },
  { src: "/logos/brands/wildcraft.png", title: "Wildcraft" },
  { src: "/logos/brands/kisna-jewels.png", title: "Kisna Diamond Jewellery" },
  { src: "/logos/brands/talwarsons.png", title: "Talwarsons" },
  { src: "/logos/brands/cfs.png", title: "CFS" },
  // Misc / Lifestyle
  { src: "/logos/brands/triveni.png", title: "Triveni" },
  { src: "/logos/brands/myfair.png", title: "Myfair" },
  { src: "/logos/brands/ikrish.png", title: "Ikrish" },
];

export const TICKER_MEDIA = [
  "Times of India",
  "Dainik Jagran",
  "Hindustan Times",
  "Dainik Bhaskar",
  "Amar Ujala",
  "Rajasthan Patrika",
  "The Hindu",
  "Ananda Bazar Patrika",
  "Eenadu",
  "Lokmat",
  "Aaj Tak",
  "News18",
  "ABP News",
  "NDTV",
  "India TV",
  "Radio Mirchi",
  "Red FM",
  "Radio City",
  "My FM",
  "Big FM",
  "Fever FM",
  "Qube Cinema",
  "Times Internet",
  "HT Digital Streams",
];

export const TICKER_LANGUAGES = [
  { native: "हिन्दी", english: "Hindi" },
  { native: "English", english: "English" },
  { native: "ਪੰਜਾਬੀ", english: "Punjabi" },
  { native: "বাংলা", english: "Bengali" },
  { native: "मराठी", english: "Marathi" },
  { native: "ગુજરાતી", english: "Gujarati" },
  { native: "தமிழ்", english: "Tamil" },
  { native: "తెలుగు", english: "Telugu" },
  { native: "ಕನ್ನಡ", english: "Kannada" },
  { native: "മലയാളം", english: "Malayalam" },
  { native: "ଓଡ଼ିଆ", english: "Odia" },
  { native: "অসমীয়া", english: "Assamese" },
  { native: "اردو", english: "Urdu" },
  { native: "नेपाली", english: "Nepali" },
  { native: "संस्कृत", english: "Sanskrit" },
  { native: "भोजपुरी", english: "Bhojpuri" },
  { native: "डोगरी", english: "Dogri" },
  { native: "कश्मीरी", english: "Kashmiri" },
];

export const SERVICES = [
  {
    id: "print",
    number: "01",
    name: "Print & Publications",
    bullets: [
      "873+ newspaper and magazine partners across 18 languages",
      "From Times of India and Dainik Jagran to vernacular titles your audience reads in Tier 2 and Tier 3 markets",
      "Planned by market, by language, by edition — not by rate card",
      "Annual deals lock in rates and inventory before the market moves",
    ],
    expanded:
      "Language coverage: Hindi, Urdu, Bengali, Telugu, Marathi, Gujarati, Punjabi, Tamil, Malayalam, Kannada, and more. We also cover magazines and inflight titles — Grihshobha, Forbes India, Meri Saheli, Hello 6E — for brands that need depth beyond daily newspapers.",
  },
  {
    id: "broadcast",
    number: "02",
    name: "Broadcast Media",
    bullets: [
      "Television and radio across national and regional networks",
      "Aaj Tak, News18, NDTV, Jio News, Radio Mirchi, Red FM, Radio City, Big FM, and beyond",
      "Planned by slot, station, and market — not by what's easiest to book",
    ],
    expanded:
      "Prime time and high-frequency slots are negotiated at annual contract rates — not booked at market rate when a campaign brief arrives. That timing advantage is the difference between the slot your audience watches and the one that's left.",
  },
  {
    id: "ooh",
    number: "03",
    name: "Out-of-Home",
    bullets: [
      "Hoardings, transit media, cinema, airport, and auto branding across metro and Tier 2 markets",
      "Specialist partner network for execution and quality control",
      "Visual confirmation on every placement — standard, not optional",
    ],
    expanded:
      "Partner network: Qube Cinema (national multiplex and single-screen), TIM Delhi Airport, Decode Advertising, and Blue Box Media — covering metro high-traffic sites and regional market presence.",
  },
  {
    id: "government",
    number: "04",
    name: "Government Advertising",
    bullets: [
      "DAVP-empanelled for Central Government mandates — statutory notices, tenders, public announcements, and government campaigns",
      "State-level coverage through our empanelment with UPID and Rajasthan Samvad",
      "A credential most private-sector agencies can't access",
    ],
    expanded:
      "Our strategic partnership with National Advertising Agency extends our government advertising reach beyond DAVP, UP, and Rajasthan — bringing over 100 years of specialised government media expertise to every mandate we handle.",
  },
  {
    id: "digital",
    number: "05",
    name: "Digital",
    bullets: [
      "Search, social, and programmatic advertising",
      "Managed through Times Internet Limited, HT Digital Streams, and specialist digital partners",
      "A capability we're building deliberately, not as an afterthought",
    ],
    expanded:
      "Digital is planned in context of the full media mix — not in isolation. Spend is calibrated against print and broadcast to avoid duplication and maximise reach efficiency across channels.",
  },
  {
    id: "creative",
    number: "06",
    name: "Strategy & Creative",
    bullets: [
      "Branding, design, copywriting, and more — in-house, through Transmitter",
      "Media budget planning, campaign strategy, and go-to-market advisory",
      "For clients who want an advisor, not just a buying desk",
    ],
    expanded:
      "Strategy and creative under one roof — the same brief, the same timeline, the same accountability. No handoffs between a media agency and a separate creative shop. One conversation, start to finish.",
  },
];

export const CASE_STUDIES = [
  {
    sector: "FMCG",
    headline: "National print presence\nacross 14 states.",
    body:
      "A packaged goods brand expanding beyond its home markets needed credible multi-edition print coverage across North and Central Bharat. We planned and deployed across multiple publications simultaneously, with full MIS confirmation before 10:00 AM on day of publication.",
    stats: ["14 states", "Multi-publication", "Day-of MIS"],
  },
  {
    sector: "Healthcare",
    headline: "Ten years. Forty markets.\nStill growing.",
    body:
      "Some of our healthcare clients have been with us since 2013 — not because we locked them in, but because the rates we negotiate and the coverage we deliver keep delivering. Long relationships are how we measure success.",
    stats: ["10+ yr relationship", "National print + broadcast", "Multi-brand"],
  },
  {
    sector: "Education",
    headline: "Admissions season,\nhandled.",
    body:
      "Education brands face a compressed, high-stakes advertising window every year. We plan print, radio, and OOH in parallel — across the markets that matter for each institution — so no campaign slot is wasted.",
    stats: ["Multi-market", "Print + Radio + OOH", "Admissions window"],
  },
];

export const DIFFERENTIATORS = [
  {
    n: "01",
    title: "We reach where national media doesn't.",
    body:
      "Active buying in 18 languages across 1,000+ media partners — from national outlets to vernacular properties serving Tier 2, Tier 3, and rural markets.",
  },
  {
    n: "02",
    title: "One call covers it all.",
    body:
      "Media planning and buying, in-house creative through Transmitter, hyperlocal execution through Hype N Hike, and government advertising through DAVP empanelment — one relationship, one point of accountability.",
  },
  {
    n: "03",
    title: "You know your ad ran before your business day starts.",
    body:
      "MIS confirmation of published advertisements by 10:00 AM on the day of publication — plus visual confirmations for OOH and cinema as standard. Full post-campaign audit trails. This discipline is not universal in Indian media buying.",
  },
];

export const ACCREDITATIONS = [
  { label: "INS Accredited", note: "Indian Newspaper Society" },
  { label: "DAVP Empanelled", note: "Central Government advertising" },
  { label: "Public Limited", note: "Elevated June 2024" },
];

export const AWARDS = [
  { org: "Times Group", name: "Power Icon Award", year: "2021" },
  { org: "Dainik Jagran", name: "Brand Strategy Innovation", year: "2024" },
  { org: "Dainik Jagran", name: "Excellence in Media/Communication Design", year: "2024" },
  { org: "Dainik Jagran", name: "Certificate of Excellence — Achiever", year: "2024" },
  { org: "Radio City", name: "Punjab Icon Award", year: "2023" },
  { org: "Big FM", name: "Big Impact Award — Business of Punjab", year: "2023" },
  { org: "MY FM 94.3", name: "Excellence Award", year: "—" },
  { org: "Dainik Bhaskar", name: "Advertising Excellence Award", year: "2009" },
];

export const INSIGHTS = [
  {
    n: "01",
    category: "Editorial",
    title: "The Future of Vernacular: Why Local Language Is Winning the Ad-War",
    date: "Coming soon",
  },
  {
    n: "02",
    category: "Analysis",
    title: "Post-IPL Media Planning: What Brands Need to Know",
    date: "Coming soon",
  },
  {
    n: "03",
    category: "Industry",
    title: "OOH Innovation: Beyond the Static Billboard",
    date: "Coming soon",
  },
];

export const OFFICES = [
  {
    city: "Ludhiana",
    note: "HO",
    address:
      "SCF 24–25–26, 2nd Floor, SBS Nagar, Main Market, Pakhowal Road, Ludhiana 141013",
  },
  {
    city: "Delhi",
    address:
      "708, 7th Floor, Padma Towers Building-I, Rajendra Place, New Delhi 110008",
  },
  {
    city: "Mumbai",
    address:
      "814, Corporate Annexe, Sonawala Road, Goregaon East, Mumbai 400063",
  },
  {
    city: "Chandigarh",
    address: "SCO-181, 2nd Floor, Sector 37C, Chandigarh 160036",
  },
  {
    city: "Jaipur",
    address:
      "8th Floor, Pink City Building, Ashok Marg, C-Scheme, Jaipur 302001",
  },
  {
    city: "Lucknow",
    address:
      "B1/719, 7th Floor, DLF My Pad, Vibhuti Khand, Gomti Nagar, Lucknow 226010",
  },
  {
    city: "Shimla",
    address: "JPH Niwas, Cemetery Road, Sanjauli, Shimla 171006",
  },
];

export const CONTACT = {
  address:
    "SCF 24-25-26, 2nd Floor, SBS Nagar, Main Market, Pakhowal Road, Ludhiana, Punjab 141013",
  phone: "0161-4642371",
  email: "info@designindya.com",
};

export const MEDIA_PARTNERS = {
  "National Newspapers": [
    "Times of India",
    "Dainik Jagran",
    "Hindustan Times",
    "Dainik Bhaskar",
    "Amar Ujala",
    "Rajasthan Patrika",
    "The Hindu",
    "Ananda Bazar Patrika",
    "Eenadu",
    "Lokmat",
  ],
  Television: ["Aaj Tak", "News18", "ABP News", "NDTV", "Jio News", "India TV"],
  Radio: [
    "Radio Mirchi 98.3",
    "Red FM",
    "Radio City 91.1",
    "My FM 94.3",
    "Big FM",
    "Fever FM",
  ],
  Cinema: ["Qube Cinema (national multiplex + single-screen)"],
  Digital: ["Times Internet Limited", "HT Digital Streams", "ABP Digital"],
  OOH: [
    "National Advertising Agency",
    "TIM Delhi Airport",
    "Decode Advertising",
    "Blue Box Media",
  ],
};

export const SECTOR_DEPTH = [
  {
    name: "Healthcare & Pharma",
    bullets: [
      "Active in this category since our earliest years — one of our deepest areas of category expertise",
      "We understand compliance requirements, the media contexts that reach healthcare decision-makers, and the vernacular publications that carry authority in Tier 2 markets",
      "Multi-edition print, regional broadcast, and OOH planned around treatment cycles, awareness campaigns, and clinic footfall objectives",
    ],
    brands: [
      "Indira IVF Hospitals",
      "Cipla Health",
      "Leeford Healthcare",
      "Torque Pharma",
    ],
  },
  {
    name: "FMCG & Wellness",
    bullets: [
      "Multi-edition, high-frequency print presence across national and regional markets simultaneously — planned by product, by season, by market",
      "Annual deal structures deliver consistent rate advantages campaign after campaign",
      "From national FMCG majors to Ayurvedic wellness brands, the media mix varies — the discipline doesn't",
    ],
    brands: [
      "Emami",
      "Divisa Herbal",
      "Zandu",
      "Boro Plus",
      "Navratna",
      "Patanjali",
      "Pushp Brand",
    ],
  },
  {
    name: "Education",
    bullets: [
      "Education brands have the most time-compressed advertising windows in any category",
      "Print, radio, and OOH planned in concert across the cities that produce the most enrolment enquiries for each institution",
      "Regional reach and precise market selection determine whether an admissions campaign converts or misses",
    ],
    brands: [
      "CT University",
      "Flame University",
      "Mody University",
      "Aakash Institute",
    ],
  },
  {
    name: "Equipment & Machinery",
    bullets: [
      "Agricultural and commercial vehicle brands require regional depth and vernacular media buying — not national broadcast slots",
      "We know which publications farming communities and rural entrepreneurs actually read, and we negotiate access to them at annual rates",
      "North and Central Bharat coverage with deliberate Tier 2 and rural market depth",
    ],
    brands: [
      "John Deere",
      "Sonalika International",
      "Kubota",
      "Indo Farm",
      "Hero Ecotech",
    ],
  },
  {
    name: "Real Estate & Infra",
    bullets: [
      "B2B brands reaching contractors, builders, and procurement decision-makers through trade and regional print",
      "Category requires sustained presence across construction hubs and regional business markets — not burst campaigns",
      "Government tender announcements handled through our DAVP empanelment",
    ],
    brands: [
      "JSW Cement",
      "Jai Bharat Steel",
      "KONE Elevators",
      "Prayag Pipes",
    ],
  },
  {
    name: "Footwear & Jewelry",
    bullets: [
      "Regional reach and vernacular publications are the difference between visibility and invisibility for these brands",
      "Distribution footprint, seasonal peaks, and local media consumption patterns all drive the media plan",
      "We plan by market and by language — not by convenience",
    ],
    brands: ["APL Footwear", "Calcetto", "Aeroblu", "HK Jewels"],
  },
];

export const OPERATING_PRINCIPLES = [
  {
    title: "Better reach at better rates.",
    body: [
      "Our original promise was simple: connect Indian brands to their audience at rates no single brand can negotiate alone.",
      "Everything since — the offices, the team, the group structure — has been built to keep that promise.",
    ],
  },
  {
    title: "Bharat is more than metros.",
    body: [
      "Since 2008, we've bought media in the places national agencies don't prioritize.",
      "For us, taking brands to vernacular publications, regional broadcasters, and markets in Tier 2 and beyond has always been the ground truth, not a trend.",
    ],
  },
  {
    title: "Relationships should outlast campaigns.",
    body: [
      "Our average brand relationship lasts seven years.",
      "Divisa Herbal since 2013. Emami and Indira IVF since 2015. Shree Dhootapapeshwar since 2017…",
      "A long list of long relationships is the product of consistent delivery — not of contracts.",
    ],
  },
];
